export default __webpack_public_path__ + "images/View_of_Genitalia.e4e4182438e6ca56b590654300da1b23.png";